export default "__VITE_ASSET__db73675d__"